import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import TextArea from '../../../../../../common/components/c_TextArea';
import FlatButton from '../../../../../../common/components/c_FlatButton';
import cx from 'classnames';

export default class JobRequestDescription extends Component {

  static propTypes = {
    jobRequest: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

   constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      jobrequest: {
        description: props.jobRequest.description
      }
    }

  }

  handleChange = (event, value) => {

    this.setState({ dirty: true });
    let jobrequest = {
      id: this.props.jobRequest.id,
      primaryContactId: this.props.jobRequest.primaryContactId,
      description: value,
    }
    this.setState({jobrequest});
  }

  handleSave = (jobrequest) => {

    if(this.state.dirty === false) {
      return;
    }

    this.props.handleSave(jobrequest).then(() => {
      this.setState({dirty: false });
    });
  }

  render() {

    return (
      <div className="job-request-worksheet-description">
        <h1 className='heading'>Job Description</h1>
        <TextArea
          onChange={this.handleChange}
          className='job-description-textarea'
          value={this.state.jobrequest.description}
          disabled={this.props.disabled}
          data-id='job-description'
        />

    { this.props.disabled ? null :     <FlatButton
          className={cx('button-save', {disabled: !this.state.dirty})}
          onClick={ (e) => this.handleSave({jobrequest: this.state.jobrequest}) }
          data-id='save'
          label='save'/> }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/Profile/Description/index.js